// ** Reactstrap
import { Input, Label } from "reactstrap";
import { Controller } from "react-hook-form";
import CustomTooltip from "../ui-components/tooltip";
// ** Third Party
import Proptypes from "prop-types";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

const SwitchField = (props) => {
    const { t } = useTranslation();
    const {
        label,
        name,
        disabled = false,
        control,
        className = "",
        customOnChange = () => {},
        desc = "",
        tooltipContent = "",
        id
    } = props;

    return (
        <div
            className={classnames("form-switch p-0 align-items-start d-flex flex-column", {
                [className]: className,
                disabled
            })}>

            {label && (
                <Label htmlFor={name} className="me-1 mb-0" data-cy={`label-${id}`}>
                    {t(label)}
                    {Boolean(tooltipContent) && (
                        <>
                            <i className="mdi mdi-information-outline ms-75" id={`tooltip-${id}`} />
                            <CustomTooltip 
                                target={`tooltip-${id}`} content={tooltipContent} />
                        </>
                    )}
                </Label>
            )}

            <Controller
                name={name}
                control={control}
                render={({ field: { onChange, value } }) => (
                    <Input
                        onChange={(e) => {
                            customOnChange?.(e.target.checked);
                            onChange(e);
                        }}
                        data-cy={`switch-${name}`}
                        type="switch"
                        checked={!!value}
                        id={name}
                        disabled={disabled}/>
                )}/>

            {desc && (
                <small className="fw-bold">
                    <i>{desc}</i>
                </small>
            )}
        
        </div>
    );
};

export default SwitchField;

SwitchField.propTypes = {
    id            : Proptypes.string,
    name          : Proptypes.string.isRequired,
    control       : Proptypes.any.isRequired,
    disabled      : Proptypes.bool,
    className     : Proptypes.string,
    desc          : Proptypes.string,
    tooltipContent: Proptypes.string,
    customOnChange: Proptypes.func
};
